export default {
  PROJECT_PATH_REGEX: /^.*\/project-doc\/.*\/version\/\w*/,
  PROJECT_CODE_PATH_REGEX: /^.*\/project\/(.*)$/,
  PROTOBUF_CODE_PATH_REGEX: /^.*\/project\/(.*)\/protobuf$/,
  MOCK_DEPLOYMENT_CODE_PATH_REGEX: /^.*\/project\/(.*)\/mock-deployment$/,
  PROJECT_CODE_PATH_VERSION_REGEX: /^.*\/project-doc\/(.*?)\/(.*)\/version\/([\w]*)\/?.*$/,
};
